module.exports = "/static/media/empty_payment_icon.8e384d05.svg";